export const getCountryFormDefinition = (value: server.dto.Countries, serverReference: server.dto.ServerReference): server.dto.CompanyFormElementsForCountryDefinition => {
  return serverReference.countryFormDefinitions.find(l => l.key === value)!;
}